$( () => {
    if ($(".swiper-services").length > 0) {
		var swiperServices = new Swiper(".swiper-services", {
			slidesPerView: 'auto',
			spaceBetween: 18,
			navigation: {
				nextEl: ".service-next",
				prevEl: ".service-prev",
			},
			breakpoints: {
				768: {
					// slidesPerView: 'auto',
				},
				992: {
					// slidesPerView: 2,
				},
				1200: {
					// slidesPerView: 3,
				},
			},
		});
	}
    if ($(".swiper-products").length > 0) {
		var swiperProducts = new Swiper(".swiper-products", {
			slidesPerView: 'auto',
			spaceBetween: 18,
			loop: true,
			navigation: {
				nextEl: ".product-next",
				prevEl: ".product-prev",
			},
			breakpoints: {
				768: {
					// slidesPerView: 'auto',
				},
				992: {
					// slidesPerView: 2,
				},
				1200: {
					// slidesPerView: 3,
				},
			},
		});
	}
    if ($(".swiper-products-popular").length > 0) {
		var swiperProductsPopular = new Swiper(".swiper-products-popular", {
			slidesPerView: 1,
			spaceBetween: 18,
			loop: true,
			navigation: {
				nextEl: ".productPopular-next",
				prevEl: ".productPopular-prev",
			},
			breakpoints: {
				// when window width is >= 768px
				768: {
				  slidesPerView: 2,
				  spaceBetween: 20
				},
				992: {
				  slidesPerView: 5,
				  spaceBetween: 20
				}
			}
		});
	}
});



// WEBPACK FOOTER //
// ./resources/assets/js/modules/slider.js